<div class="home-hero center-content">
    <div class="hero-text animate__animated animate__bounceIn">
        <h1 class="logo-text">Andrés Vargas</h1>
        <h2 class="sub-text animate__animated animate__fadeInUp">Full Stack Developer</h2>
    </div>
    <div>
        <section class="hero-section animate__animated animate__bounceIn">
            <div class="row">
                <div class="column intro-column ">
                    <p>
                        Hi, I'm Andres, a Software Engineer from Colombia living in Australia. I have over 10 years of experience in creating web and mobile applications using cutting-edge technologies and frameworks, such as Angular, React, NodeJS, Apache Cordova, and Unity3D. I also hold a master's degree in Programming in HTML5 with JavaScript and CSS3, and I'm a certified Unity developer.
                    </p>
                </div>
            </div>
             <div class="row">
                <div class="column skills-column">
                    <h3>Web development</h3>
                    <ul>
                        <li>JavaScript / TypeScript</li>
                        <li>Angular / React</li>
                        <li>Node.js / Express</li>
                        <li>HTML / CSS / SASS</li>
                        <li>MongoDB / SQL / MySQL</li>
                    </ul>
                </div>
            </div>
             <div class="row">
                <div class="column skills-column">
                    <h3>Apps development</h3>
                    <ul>
                        <li>Swift / React Native / Ionic / Unity3D</li>
                    </ul>
                </div>
            </div>
            <div class="row">
                <div class="column skills-column">
                    <h3>Programming languages</h3>
                    <ul>
                        <li>JavaScript / Swift / C# / PHP / Python</li>
                    </ul>
                </div>
            </div>
        </section>
    </div>
</div>
